import { useFormDataContext } from "@totalenergiescode/mobility-business-rev-form-data/components";
import type { FormFieldContract } from "@totalenergiescode/mobility-business-rev-form-data/lib";

interface ViolationListProps {
  field: FormFieldContract;
}

const ViolationList = ({ field }: ViolationListProps) => {
  const { translatorFor } = useFormDataContext();
  const translator = translatorFor(field);
  // We don't render anything if there is no violation
  if (!field.hasViolations()) {
    return null;
  }

  return (
    <>
      <ul>
        {field.violations().map((violation) => (
          <li>{violation.translate(translator)}</li>
        ))}
      </ul>
    </>
  );
};

export default ViolationList;
